import React from 'react';
import classNameBind from 'classnames/bind';
import Label from '../../../Label';
import Icon from '../../../Icon';
import styles from './Empty.module.css';

const bindClasses = classNameBind.bind(styles);

const Empty = ({ children, type }) => (
  <div
    className={bindClasses('wrapper', type)}
    data-ppuc-id="Sidebar.Empty"
  >
    {type === 'error' && <Icon name="exclamation-mark-circle" color="red" className={bindClasses('icon')} />}
    <Label type="small">{children}</Label>
  </div>
);

export default Empty;
